import { AppAreaConfig } from './@types'
import { PaywallRoute, UpsellRoute, UpgradeRoute } from '@/@types/router-types'

// Runtime type guard
export const isAppAreaConfig = (config: unknown): config is AppAreaConfig => {
	return (
		typeof config === 'object' && config !== null && 'appArea' in config && 'landing' in config && 'funnel' in config
	)
}

// Default values from main funnel for redirect funnels fallbacks
const DEFAULT_PAYWALL_CONFIG: { routeName: PaywallRoute } = {
	routeName: 'plan-main',
}

const DEFAULT_UPSELL_CONFIG: { routeNames: UpsellRoute[] } = {
	routeNames: ['upsell-static-subscription-activated', 'upsell-f'],
}

const DEFAULT_UPGRADE_CONFIG: { routeName: UpgradeRoute | null } = {
	routeName: null,
}

// Generic helper to get config value with fallback
const getConfigValue = <T extends object, K extends keyof T>(obj: T | undefined, key: K, defaultValue: T[K]): T[K] => {
	return obj && key in obj ? obj[key] : defaultValue
}

// Helper functions to get config values with fallbacks
export const getPaywallRouteName = (config: AppAreaConfig): string =>
	getConfigValue(config.paywall, 'routeName', DEFAULT_PAYWALL_CONFIG.routeName)

// eslint-disable-next-line import/no-unused-modules
export const getUpsellRouteNames = (config: AppAreaConfig): string[] =>
	getConfigValue(config.upsell, 'routeNames', DEFAULT_UPSELL_CONFIG.routeNames)

// eslint-disable-next-line import/no-unused-modules
export const getUpgradeRouteName = (config: AppAreaConfig): string | null =>
	getConfigValue(config.upgrade, 'routeName', DEFAULT_UPGRADE_CONFIG.routeName)
